class AnnouncementBarEmbla extends HTMLElement {
  constructor() {
    super();
    this.emblaNode = this.querySelector(".embla__viewport");
    this.options = { loop: true, align: "center", draggable: true };
    this.plugins = [];
    this.embla = null;

    // Autoplay configuration
    this.autoplayEnabled = this.dataset.autoplay === "true";
    this.autoplaySpeed = parseInt(this.dataset.speed || 5000);
    this.autoplayInterval = null;

    this.init();
  }

  async init() {
    // Wait for Embla
    if (typeof EmblaCarousel === "undefined") {
      await this.waitForEmbla();
    }

    if (typeof EmblaCarousel === "undefined") {
      console.error("Embla Carousel not available for Announcement Bar");
      return;
    }

    // Initialize Embla
    const Embla = EmblaCarousel;
    this.embla = Embla(this.emblaNode, this.options, this.plugins);

    // Initial autoplay
    if (this.autoplayEnabled) {
      this.startAutoplay();

      // Stop/Resume on interaction
      this.embla.on("pointerDown", () => this.stopAutoplay());
      this.embla.on("pointerUp", () => this.startAutoplay());
    }
  }

  waitForEmbla() {
    return new Promise((resolve) => {
      if (typeof EmblaCarousel !== "undefined") {
        resolve();
        return;
      }
      const check = setInterval(() => {
        if (typeof EmblaCarousel !== "undefined") {
          clearInterval(check);
          resolve();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(check);
        resolve();
      }, 5000);
    });
  }

  startAutoplay() {
    this.stopAutoplay(); // Clear existing
    this.autoplayInterval = setInterval(() => {
      if (this.embla && this.embla.canScrollNext()) {
        this.embla.scrollNext();
      }
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  disconnectedCallback() {
    if (this.embla) this.embla.destroy();
    this.stopAutoplay();
  }
}

customElements.define("announcement-bar-embla", AnnouncementBarEmbla);
